import { inject, Injectable, InjectionToken } from '@angular/core';
import { LoggerProvider } from './logger-provider.service';
import { LogLevel } from './loglevel.enum';

export const MIN_LOG_LEVEL = new InjectionToken<LogLevel>('Minimum log level');
export const LOGGER_PROVIDERS = new InjectionToken<LoggerProvider[]>(
    'Log providers'
);

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    constructor() {}

    readonly #minLogLevel = inject(MIN_LOG_LEVEL) ?? LogLevel.NEVER;
    readonly #providers = inject(LOGGER_PROVIDERS) ?? [];

    private canLog(logLevel: LogLevel): boolean {
        return logLevel >= this.#minLogLevel;
    }

    debug(template: string, ...optionalParams: any[]): void {
        if (this.canLog(LogLevel.DEBUG)) {
            this.#providers.forEach((provider) =>
                provider.debug(template, ...optionalParams)
            );
        }
    }

    info(template: string, ...optionalParams: any[]): void {
        if (this.canLog(LogLevel.INFO)) {
            this.#providers.forEach((provider) =>
                provider.info(template, ...optionalParams)
            );
        }
    }

    warning(template: string, ...optionalParams: any[]): void {
        if (this.canLog(LogLevel.WARNING)) {
            this.#providers.forEach((provider) =>
                provider.warning(template, ...optionalParams)
            );
        }
    }

    error(template: string, ...optionalParams: any[]): void {
        if (this.canLog(LogLevel.ERROR)) {
            this.#providers.forEach((provider) =>
                provider.error(template, ...optionalParams)
            );
        }
    }
}
